export const formatSelectOptions = (options: any) => {
  const response = [] as any;
  options?.map((option: any) => {
    response.push({ label: option?.name, value: option?.id });
  });
  return response;
};
